import { Group, Pagination, Text } from "@mantine/core";

interface CVListPaginationProps {
    isFiltered: boolean;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    totalItems: number;
    filteredCount: number;
    onPageChange: (page: number) => void;
}

export function CVListPagination({
    isFiltered,
    totalPages,
    pageIndex,
    pageSize,
    totalItems,
    filteredCount,
    onPageChange,
}: CVListPaginationProps) {
    if (isFiltered) {
        return (
            <Group justify="center" mt="xl" p="xs">
                <Text size="sm" c="dimmed">
                    Showing all {filteredCount} filtered results
                </Text>
            </Group>
        );
    }

    if (totalPages <= 1) {
        return null;
    }

    return (
        <Group justify="apart" mt="xl" p="xs">
            <Text size="sm">
                Showing {pageIndex * pageSize + 1}-
                {Math.min((pageIndex + 1) * pageSize, totalItems)} of{" "}
                {totalItems} results
            </Text>
            <Pagination
                total={totalPages}
                value={pageIndex + 1}
                onChange={onPageChange}
                size="sm"
                radius="md"
                withEdges
            />
        </Group>
    );
}

